export class spsHelper {
    amount = 0;
    amountDeposit = 0;
    spsUrl;

    constructor(spsUrl) {
        this.spsUrl = spsUrl;
    }

    loadJquery(callback) {
        let $this = this;
        const jq = document.createElement('script');
        jq.src = './libs/jquery.3-7-1.min.js';
        if (jq.src) {
            document.getElementsByTagName('head')[0].appendChild(jq);
        }

        let hasjQueryInterval = setInterval(function () {
            if (window.jQuery) {
                clearInterval(hasjQueryInterval);

                let jsps = document.createElement('script');
                jsps.src = $this.spsUrl;
                document.getElementsByTagName('head')[0].appendChild(jsps);
            }
        }, 1000);

        let interval = setInterval(function () {
            if (window.C24SpsClient !== undefined && window.C24SpsClient.defaults !== undefined) {
                clearInterval(interval);
                callback();
            }
        }, 1000);
    }

    static initSps() {
        window.C24SpsClient.defaults.apiService = '133';
        window.C24SpsClient.defaults.cardTypes = [
            window.C24SpsClient.const.CARD_VISA,
            window.C24SpsClient.const.CARD_MASTERCARD,
            window.C24SpsClient.const.CARD_AMERICAN_EXPRESS,
        ];
        window.C24SpsClient.defaults.device = window.C24SpsClient.const.DEVICE_TABLET;
        // window.C24SpsClient.defaults.errorTemplate = '<div class="error-group sps-error form-errors"></div>';
        window.C24SpsClient.defaults.autoSubmit = true;
        window.C24SpsClient.defaults.prefill = true;
        window.C24SpsClient.defaults.showInputClear = true;
    }
}

export default spsHelper;
